// https://stackoverflow.com/questions/44065854/make-button-group-look-like-radio-button

import React, { Component } from 'react'

class TrendButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeOption: this.props.options[0],
    }
  }

  /**
   * 選択された事例ボタンの活性／非活性化
   * @param  {String} activeOption 事例文字列
   */
  updateActiveOption = (activeOption) => {
    this.setState({
      activeOption,
    })
  }
  
  render() {
    return (
      <div
        style={{
            display: 'flex',
            justifyContent: 'start',
            flexWrap: 'wrap',
            marginTop: 20,
            marginBottom: 20
        }}
      >

        {this.props.options.map((option, idx) => {

          return (
            <button
            onClick={() => {
              this.props.onChange(option)
              this.updateActiveOption(option)
            }}
            style={{
              fontWeight: this.state.activeOption === option ? '800' : '600',
            }}
            className={`trend ${this.state.activeOption === option ? 'active' : 'inactive'}`}
            key={idx}
          >
            <span>{option.trendWord}</span>
          </button>
          )
        })}
      </div>
    )
  }
}

export default TrendButton
